(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireaf93"];
var parcelRegister = parcelRequire.register;
parcelRegister("1f7RP", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $0e7d4b681c6c6090$export$b3890eb0ae9dca99; });
/**
 * File video.js.
 *
 * Pauses and plays video on btn-video click.
 *
 * Learn more: https://git.io/vWdr2
 */ function $0e7d4b681c6c6090$export$b3890eb0ae9dca99() {
    /* Get the video containers */ var videoContainers = document.querySelectorAll(".video-container");
    // If there are no video containers, return early
    if (!videoContainers) return;
    /* Loop through the video containers */ videoContainers.forEach(function(videoContainer) {
        // Get the video element
        var video = videoContainer.querySelector("video");
        var btn = videoContainer.querySelector(".btn-video");
        // Add click event listener to the button
        btn.addEventListener("click", function(e) {
            /* Prevent default behavior */ e.preventDefault();
            if (!video.paused) {
                btn.innerHTML = "Play";
                btn.classList.toggle("play");
                video.pause();
            } else {
                btn.innerHTML = "Pause";
                btn.classList.toggle("play");
                video.play();
            }
        });
    });
}

});

})();
//# sourceMappingURL=banner.323a90c7.js.map
